import { queryKeys } from '@query/keys'
import { usePaginatedQuery } from '@query/usePaginatedQuery'
import { useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { useNavigate } from '@lib/react-router-dom'

import { PageData, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { DemoTradingAccount } from '@model/TradingAccount'

import { Loading } from '@shared/components/Loading/Loading'

import {
  DemoTradingAccountDepositForm,
  DemoTradingAccountDepositFormValues,
} from './DemoTradingAccountDepositForm'

export const DemoTradingAccountDepositPage = () => {
  const { tradingAccountId } = useParams<{ tradingAccountId?: string }>()
  const apiClient = useApiClient(ClientApiClient)
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const onSubmit = async (values: DemoTradingAccountDepositFormValues) => {
    await apiClient.addBalanceToDemoTradingAccount(values)

    queryClient.removeQueries({ queryKey: ['tradingAccount'] })
    navigate(`/dashboard/traders-room/trading-accounts/demo`)
  }

  const { data, isLoading } = usePaginatedQuery<DemoTradingAccount>({
    queryKey: queryKeys.tradingAccount.demoDeposit(tradingAccountId),
    queryFn: () => {
      if (tradingAccountId) {
        return apiClient.getDemoTradingAccounts({
          search: { Id: tradingAccountId },
        })
      }
      return Promise.resolve({
        items: [],
        itemsCount: 0,
        totalPages: 0,
        pageIndex: 0,
        pageSize: 0,
        totalResults: 0,
      } as PageData<DemoTradingAccount>)
    },
  })
  return (
    <>
      <Loading isLoading={isLoading}>
        {data.length && (
          <DemoTradingAccountDepositForm
            demoTradingAccounts={data[0]}
            handleFormSubmit={onSubmit}
          />
        )}
      </Loading>
    </>
  )
}
